import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stumbleupon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2v70.6c0 14.7 12 26.5 26.7 26.5s26.8-11.8 26.8-26.5v-72h85.9zM278.2 207.8v-30.9c0-14.7-12-26.7-26.7-26.7s-26.7 12-26.7 26.7v160.3c0 61.3-50.8 110.8-112.4 110.8-62.1 0-112.4-50.3-112.4-112.3v-69.7h86v68.6c0 14.9 12 26.7 26.7 26.7s26.7-11.8 26.7-26.7v-162.4c0-60 51.3-108.2 112.1-108.2 61 0 112.1 48.5 112.1 109v35.6l-51.1 15.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stumbleupon.js
// module id = 1041
// module chunks = 0